module.exports = __webpack_public_path__ + "static/img/cop_sch_logo23.b8171cc2.png";